module.exports = __webpack_public_path__ + "static/WelcomeToCare-a623ff3a5a5ff78e6895be7baa876086.jpg";